module.exports = __webpack_public_path__ + "static/media/about_banner.47ed5779.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/about_banner.png
// module id = 52
// module chunks = 0